import { TrainingsSessionModalityEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const useValidation = () => {
  const validateLink = (link: string) => {
    if (link.length > 0 && !link.startsWith('https://')) {
      return i18n.t('trainings.common.link_validation')
    }
  }

  const validateWorkflows = ({
    workflowStatus,
    processId,
  }: {
    workflowStatus: boolean
    processId?: string
  }) => {
    if (workflowStatus && !processId) {
      return 'This is a mandatory field'
    }
  }

  const validateModality = ({
    modality,
    link,
    location,
  }: {
    modality: TrainingsSessionModalityEnum
    link?: string
    location?: string
  }) => {
    switch (modality) {
      case 'mixed':
        return !link && !location
      case 'inperson':
        return !location
      case 'online':
        return !link
    }
  }

  return {
    validateLink,
    validateModality,
    validateWorkflows,
  }
}
